import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../styled/Modal.styled';
import { useVHWebModalContext } from '../../VHWebModalBase/VHWebModalBaseContext';

const CardModal = ({
  show,
  children,
  label,
  side,
  minWidth,
  maxWidth,
  onHide,
}) => {
  const VHWebModalContext = useVHWebModalContext();
  return (
    <Styled.ModalTweaked
      $maxWidth={maxWidth}
      onHide={onHide}
      show={show}
      containerRef={VHWebModalContext.current}
    >
      <Styled.ModalInner
        aria-label={label}
        minWidth={minWidth}
        side={side}
        maxWidth={maxWidth}
      >
        <Styled.PaddedContent>{children}</Styled.PaddedContent>
      </Styled.ModalInner>
    </Styled.ModalTweaked>
  );
};

CardModal.defaultProps = {
  label: 'Patient Info',
};

CardModal.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool.isRequired,
  label: PropTypes.string,
  side: PropTypes.string,
  maxWidth: PropTypes.string,
  onHide: PropTypes.func,
};

export default CardModal;
